<template>
    <div class="row">
        <div class="col-md-12">
            <h4><i class="fa fa-shopping-cart"></i> Adicionais</h4>
            <div class="row" v-if="auth_user.ambiente === 'A'">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Valor Adicional</label>
                        <money disabled v-model="moduloAdicional.valor" class="form-control"></money>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label>Módulo</label>
                        <select @change="getModuloAdicionalValue()" v-model="moduloAdicional.fk_modulo_id" class="form-control">
                            <option :value="null">{{$t('words.select')}}</option>
                            <option v-show="item.tipo == 'ADICIONAL'" v-for="item in modulos" :key="item.id" :value="item.id">
                                {{item.nome}} - {{formatMoney(item.valor)}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <required /> <label>
                            Validade</label>
                        <div class="input-group">
                            <select @change="getModuloAdicionalValue()" v-model="moduloAdicional.fk_validade_id"
                                class="form-control">
                                <option :value="null">{{$t('words.select')}}</option>
                                <option v-for="item in validades" :key="item.id" :value="item.id">
                                    {{item.nome}} - {{item.vencimento}}</option>
                            </select>
                            <span class="input-group-btn">
                                <button @click="addModuloAdicional()" :disabled="!moduloAdicional.fk_validade_id"
                                    class="btn btn-secondary"><i class="fa fa-plus"></i>
                                    {{$t('words.save')}}</button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <table class="table table-sm table-condensed">
                        <thead>
                            <tr>
                                <th v-if="auth_user.ambiente === 'A'">#</th>
                                <th>Módulo</th>
                                <th>Vencimento</th>
                                <th>Quantidade</th>
                                <th>Valor</th>
                                <th>Compra Adicional?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in empresa.adicionais" :key="i">
                                <td v-if="auth_user.ambiente === 'A'"><a @click="removeModuloAdicional(item, i)" href="#"><i
                                            class="fa fa-trash text-red"></i></a></td>
                                <td>{{item.modulo.descricao}}</td>
                                <td>{{formatDate(item.vencimento)}}</td>
                                <td>{{item.quantidade}} x</td>
                                <td>{{formatMoney(item.valor)}}</td>
                                <td>
                                    <span v-if="!item.default" class="text-green"><i class="fa fa-check-circle"></i>
                                        Sim</span>
                                    <span v-else class="text-red"><i class="fa fa-times-circle"></i>
                                        Não</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            empresa: {},
            planos: {},
            validades: {}
        },
        data() {
            return {
                moduloAdicional: {
                    id: null,
                    tipo: null,
                    valor: 0,
                    vencimento: null,
                    default: false,
                    fk_validade_id: null,
                    fk_modulo_id: null,
                    fk_empresa_id: null,
                },
            }
        },
        computed: {
            modulos() {
                return this.$store.state.planoModulo.select;
            },
            user() {
                return this.$store.state.user;
            }
        },
        beforeMount() {
            
            
        },
        methods: {
            getModuloAdicionalValue() {
                let date = this.validades.find(validade => validade.id == this.moduloAdicional.fk_validade_id);
                let modulo = this.modulos.find(modulo => modulo.id == this.moduloAdicional.fk_modulo_id);
                if (date && modulo) {
                    this.moduloAdicional.valor = modulo.valor;
                    this.moduloAdicional.valor = modulo.valor * parseInt((date.vencimento / 30));
                    this.moduloAdicional.vencimento = new Date(new Date().setDate(new Date().getDate() +
                            date.vencimento))
                        .toISOString()
                        .substring(0, 10)
                }
            },
            addModuloAdicional() {
                this.moduloAdicional.fk_empresa_id = this.empresa.id;
                this.$store.dispatch('storeCompanyAditional', this.moduloAdicional).then(response => {
                    toastr({
                        title: response.message,
                        icon: response.status
                    });
                    this.moduloAdicional.id = response.id;
                    this.moduloAdicional.tipo = response.tipo;
                    this.empresa.adicionais.push(_.cloneDeep(this.moduloAdicional));
                    this.moduloAdicional.id = null;
                    this.moduloAdicional.valor = 0;
                    this.moduloAdicional.fk_validade_id = null;
                    this.moduloAdicional.fk_modulo_id = null;
                });
            },
            removeModuloAdicional(item, i) {
                this.$store.dispatch('destroyCompanyAditional', item.id).then(response => {
                    toastr({
                        title: response.message,
                        icon: response.status
                    });
                    this.empresa.adicionais.splice(i, 1);
                });
            }
        }
    }
</script>